export default __webpack_public_path__ + "static/media/calendar2.4714afd3.svg";